export class ImageUploadModel {
  imageName: string;
  imageType: string;
  imageOriginal: string;
  imageThumbnail: string;
}
